var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayer1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 1a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7.38a2 2 0 0 1 .648-1.475l4.779-4.38A2 2 0 0 1 10.778 1zm.03 14.47a.75.75 0 0 0-1.06 0l-3.334 3.333-1.866-2.988-.066-.091a.95.95 0 0 0-1.328-.152l-.084.076L6.47 19.47a.75.75 0 1 0 1.06 1.06l3.333-3.334 1.867 2.989a.95.95 0 0 0 1.478.168l3.822-3.823a.75.75 0 0 0 0-1.06M14 8a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm-3-5.573a.2.2 0 0 0-.328-.154L5.425 6.646A.2.2 0 0 0 5.553 7H10.8a.2.2 0 0 0 .2-.2zM14 4a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z"
})));
export default SvgPlayer1;